import * as L from 'leaflet';
import { toBounds } from 'leaflet/src/geometry/Bounds';

import getWmtsTileSize from '@/utils/getWmtsTileSize';
import getWmtsTileLayerUrl from '@/utils/getWmtsTileLayerUrl';

import { serviceTypes } from '../../config';

/**
 * Nadpisujemy Leafletową implementację warstwy WMS, bo musimy dodać
 * obsługę dla customowych układów CRS.
 *
 * Import znajduje się w pliku ./src/index.js (żeby nadpisać implementację w
 * całej aplikacji).
 */

L.TileLayer.WMS = L.TileLayer.WMS.extend({
  getTileUrl: function(coords) {
    var tileBounds = this._tileCoordsToNwSe(coords),
      crs = this._crs,
      bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
      min = bounds.min,
      max = bounds.max,
      bbox = (this._wmsVersion >= 1.3 &&
      (this._crs === L.CRS.EPSG4326 || this._crs.code === 'EPSG:2180')
        ? [min.y, min.x, max.y, max.x]
        : [min.x, min.y, max.x, max.y]
      ).join(','),
      url = L.TileLayer.prototype.getTileUrl.call(this, coords);

    return (
      url +
      L.Util.getParamString(this.wmsParams, url, this.options.uppercase) +
      (this.options.uppercase ? '&BBOX=' : '&bbox=') +
      bbox
    );
  }
});

L.tileLayer.wms = function(url, options) {
  return new L.TileLayer.WMS(url, options);
};

L.TileLayer.WMTS = L.TileLayer.extend({
  defaultWmtsParams: {
    service: 'WMTS',
    request: 'GetTile',
    version: '1.0.0',
    layer: '',
    style: 'default',
    tileMatrixSet: 'EPSG:2180',
    tileSize: 512
  },

  initialize: function(url, options) {
    this._url = url;

    const { tileSize, serviceType } = options;

    const format =
      serviceType === serviceTypes.wmts ? 'image/png' : 'image/jpeg';

    const tileOptions = {
      ...options,
      tileSize: getWmtsTileSize(tileSize),
      format
    };

    this.wmtsParams = L.extend({}, this.defaultWmtsParams, tileOptions);

    L.setOptions(this, tileOptions);
  },

  getTileUrl: function(coords) {
    return getWmtsTileLayerUrl({
      url: this._url,
      layer: this.wmtsParams.layer,
      style: this.wmtsParams.style,
      format: this.wmtsParams.format,
      tileMatrixSet: this.wmtsParams.tileMatrixSet,
      matrixIds: this.wmtsParams.matrixIds,
      zoomOffset: this.wmtsParams.zoomOffset,
      coords
    });
  }
});

L.tileLayer.wmts = function(url, options) {
  return new L.TileLayer.WMTS(url, options);
};

L.TileLayer.INTERNAL_WMTS = L.TileLayer.extend({
  setTileUrl: function(url, options) {
    this._url =
      url.replace('/wmts', '').replace('layer', 'wmts') +
      `/${options.gridName}`;
  },

  addTileEvents: function({ onTileError }) {
    this.on('tileerror', onTileError);
  },

  initialize: function(url, options) {
    this.setTileUrl(url, options);
    this.addTileEvents(options);

    const { tileSize } = options;

    const tileOptions = {
      ...options,
      tileSize: getWmtsTileSize(tileSize)
    };

    this.wmtsParams = L.extend({}, tileOptions);

    L.setOptions(this, tileOptions);
  },

  getTileUrl: function(coords) {
    const { z, x, y } = coords;

    return this._url + `/${z}/${x}/${y}.png`;
  }
});

L.tileLayer.internalWmts = function(url, options) {
  return new L.TileLayer.INTERNAL_WMTS(url, options);
};
